/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Steps_Col_RuleInputs */

const en_dr_steps_col_rule = /** @type {(inputs: Dr_Steps_Col_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discipline`)
};

const id_dr_steps_col_rule = /** @type {(inputs: Dr_Steps_Col_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aturan disiplin`)
};

/**
* | output |
* | --- |
* | "Discipline" |
*
* @param {Dr_Steps_Col_RuleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_steps_col_rule = /** @type {((inputs?: Dr_Steps_Col_RuleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Steps_Col_RuleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_steps_col_rule(inputs)
	return en_dr_steps_col_rule(inputs)
});